import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

import { CardContainerComponent } from './card-container/card-container.component';
import { CardComponent } from './card-container/card.component';

@NgModule({
  imports: [CommonModule, MatCardModule],
  declarations: [CardContainerComponent, CardComponent],
  exports: [CardContainerComponent]
})
export class CardContainerModule {}
